(() => {
  if (window.__locationExperienceSlider) {
    window.__locationExperienceSlider.scan();
    return;
  }

  const LOADER_SELECTOR = 'script[data-location-experience-loader]';

  const getLoaderScript = () => document.querySelector(LOADER_SELECTOR);

  const loadSwiperAssets = () => {
    if (window.Swiper) {
      return Promise.resolve();
    }

    if (window.__locationExperienceSwiperPromise) {
      return window.__locationExperienceSwiperPromise;
    }

    const loader = getLoaderScript();

    if (!loader) {
      return Promise.reject(new Error('Location experience loader script not found'));
    }

    const cssUrl = loader.dataset.swiperCss;
    const jsUrl = loader.dataset.swiperJs;

    window.__locationExperienceSwiperPromise = new Promise((resolve, reject) => {
      if (cssUrl && !document.querySelector(`link[data-location-experience-swiper-css="${cssUrl}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssUrl;
        link.setAttribute('data-location-experience-swiper-css', cssUrl);
        document.head.appendChild(link);
      }

      if (document.querySelector(`script[data-location-experience-swiper-js="${jsUrl}"]`)) {
        const waitForSwiper = () => {
          if (window.Swiper) {
            resolve();
          } else {
            setTimeout(waitForSwiper, 50);
          }
        };

        waitForSwiper();
        return;
      }

      const script = document.createElement('script');
      script.src = jsUrl;
      script.defer = true;
      script.setAttribute('data-location-experience-swiper-js', jsUrl);
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Swiper'));
      document.head.appendChild(script);
    });

    return window.__locationExperienceSwiperPromise;
  };

  const initSlider = async (root) => {
    if (!root || root.dataset.swiperInitialized === 'true') {
      return;
    }

    const swiperElement = root.querySelector('.location-experience-swiper');

    if (!swiperElement) {
      return;
    }

    if (swiperElement.clientWidth === 0) {
      requestAnimationFrame(() => initSlider(root));
      return;
    }

    try {
      await loadSwiperAssets();
    } catch (error) {
      console.warn(error);
      return;
    }

    if (swiperElement.swiper) {
      swiperElement.swiper.destroy(true, true);
    }

    const prevButton = root.querySelector('.location-experience__prev');
    const nextButton = root.querySelector('.location-experience__next');

    new window.Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: false,
      watchOverflow: true,
      observer: false,
      observeParents: false,
      resizeObserver: false,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      },
      breakpoints: {
        700: {
          spaceBetween: 20
        },
        1000: {
          spaceBetween: 24
        }
      }
    });

    root.dataset.swiperInitialized = 'true';
  };

  const destroySlider = (root) => {
    if (!root) {
      return;
    }

    const swiperElement = root.querySelector('.location-experience-swiper');

    if (swiperElement?.swiper) {
      swiperElement.swiper.destroy(true, true);
    }

    root.removeAttribute('data-swiper-initialized');
  };

  const scan = (container = document) => {
    container.querySelectorAll('[data-location-experience-slider]').forEach((root) => {
      if (root.dataset.swiperInitialized !== 'true') {
        initSlider(root);
      }
    });
  };

  window.__locationExperienceSlider = { scan, destroySlider };

  const onReady = () => scan();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-location-experience-slider]');
    destroySlider(root);
  });
})();
